export * from './doctorClinic.service';